import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import WorkReportsListItem from './WorkReportsListItem';
import WorkReportsDetails from './details/WorkReportsDetails';

import buttons from './WorkReportsButtons';
import events from './WorkReportsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('workreports'),
	routes: [
		{
			path: 'workreports/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'workreports'),
			element: (
				<DetailsPage
					key="workreports/add"
					module="workreports"
					tabs={WorkReportsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'workreports/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'workreports'),
			element: (
				<DetailsPage
					key="workreports/details"
					module="workreports"
					tabs={WorkReportsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'workreports/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'workreports'),
			element: (
				<ViewPage
					key="workreports/view"
					module="workreports"
					content={{ type: 'list', itemLayout: WorkReportsListItem, id: 'workReportsView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
